// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';
import PdbImage from '../../../pdbImage';
import { TagContainer } from '../../../tags';

export const ImageContainer = styled<any, Theme>('section')`
  position: relative;

  ${/* sc-sel */TagContainer} {
    bottom: 0;
    position: absolute;
  }
`;

export default styled<typeof PdbImage, Theme, _>(PdbImage)`
  margin-top: 1rem;
  width: 100%;
  max-width: 100%;
`;
